
module.exports = [{
    event: 'Astronomy',
    img: 'https://firebasestorage.googleapis.com/v0/b/techspardha-87928.appspot.com/o/categoryIcons%2Fastronomy.png?alt=media&token=ceaf6027-972a-4cbc-a6a0-d42e4e8196e8',

},
{
    event: 'Design',
    img: 'https://firebasestorage.googleapis.com/v0/b/techspardha-87928.appspot.com/o/categoryIcons%2Fdesign.png?alt=media&token=e713ceeb-a089-4942-8bb5-938586ff5209',

},
{
    event: 'Informals',
    img: 'https://firebasestorage.googleapis.com/v0/b/techspardha-87928.appspot.com/o/categoryIcons%2Finformals.png?alt=media&token=96afdf1f-6bc0-498f-9083-7979b637e845',

},
{
    event: 'Managerial',
    img: 'https://firebasestorage.googleapis.com/v0/b/techspardha-87928.appspot.com/o/categoryIcons%2Fman.png?alt=media&token=c8186ced-a06f-483c-832d-4ed72d17b34b',

},
{
    event: 'Online-Events',
    img: 'https://firebasestorage.googleapis.com/v0/b/techspardha-87928.appspot.com/o/categoryIcons%2Fonline.png?alt=media&token=a558612c-111b-421c-bfbc-8e52503271bb',

},
{
    event: 'Papyrus-Vitae',
    img: 'https://firebasestorage.googleapis.com/v0/b/techspardha-87928.appspot.com/o/categoryIcons%2Fpay.png?alt=media&token=e4dab2b0-4956-47f4-9599-fb726f8067b8',

},
{
    event: 'Programming',
    img: 'https://firebasestorage.googleapis.com/v0/b/techspardha-87928.appspot.com/o/categoryIcons%2Fprogramming.png?alt=media&token=6e4a1f25-bede-4f61-a8dd-46b92fe0d859',

},
{
    event: 'Quizzes',
    img: 'https://firebasestorage.googleapis.com/v0/b/techspardha-87928.appspot.com/o/categoryIcons%2Fquize.png?alt=media&token=23da041b-3a72-4b08-9637-5665fc17465c',

},
{
    event: 'Robotics',
    img: 'https://firebasestorage.googleapis.com/v0/b/techspardha-87928.appspot.com/o/categoryIcons%2Frobotics.png?alt=media&token=8737fe26-6d2c-4928-8d6c-75b3e1e35b67',

}
];